import React from "react";
import { useNavigate } from "react-router-dom";
import { FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-black/90 backdrop-blur-xl text-white pt-14 pb-8 border-t border-white/10">

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">

        {/* Company Info */}
        <div>
          <h2 className="text-2xl font-extrabold text-white">
            Codex Future Technologies Pvt. Ltd.
          </h2>
          <p className="text-gray-300 mt-3 leading-relaxed">
            Providing innovative IT solutions to businesses worldwide.
            <br /> Your success is our priority.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-3">
            <li>
              <button
                onClick={() => navigate("/about")}
                className="text-gray-300 hover:text-[#df2313] transition-all"
              >
                About Us
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/services")}
                className="text-gray-300 hover:text-[#df2313] transition-all"
              >
                Services
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/contact")}
                className="text-gray-300 hover:text-[#df2313] transition-all"
              >
                Contact Us
              </button>
            </li>
          </ul>
        </div>

        {/* Social + Contact */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Follow Us</h3>

          <div className="flex flex-wrap gap-5 text-2xl mb-6">

            {/* Phone */}
            <a
              href="tel:+919303715744"
              className="transition-all hover:text-green-500"
            >
              <FiPhone />
            </a>

            {/* Email */}
            <a
              href="mailto:codexfuturetechnologies@gmail.com"
              className="transition-all hover:text-red-500"
            >
              <FiMail />
            </a>

            {/* Facebook */}
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:text-[#1877F2]"
            >
              <FaFacebookF />
            </a>

            {/* Instagram (pink/purple) */}
            <a
              href="https://www.instagram.com/codex_future_tech_official/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:text-[#E1306C]"
            >
              <FaInstagram />
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/codex-future-technologies/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:text-[#0A66C2]"
            >
              <FaLinkedinIn />
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919303715744"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:text-[#25D366]"
            >
              <FaWhatsapp />
            </a>

          </div>



          <p className="text-gray-300">
            <span className="text-white font-semibold">Phone:</span> +91 9303715744
          </p>
          <p className="text-gray-300 mt-2">
            <span className="text-white font-semibold">Address:</span><br />
            313-14, Shagun Arcade, Vijay Nagar Square, Indore, 452010
          </p>
        </div>
      </div>

      {/* Bottom */}
      <div className="mt-12 border-t border-white/10 pt-6 text-center text-gray-400 text-sm">
        © 2025 Codex Future Technologies Pvt. Ltd. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
